import { useMutation } from "@tanstack/react-query";
import { SuperBillControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
} from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

export interface GetPatientBalanceCalculateProps {
  currentPaid: number;
  superBillId: string;
}

export const useGetPatientBalanceCalculate = () =>
  useMutation({
    mutationFn: async ({currentPaid,superBillId}: GetPatientBalanceCalculateProps) =>
      new SuperBillControllerApi(getConfigObject()).calculatePatientBalance(
        {
          currentPaid,
          superBillId,
        },
      getXtenantId()
      )
    });
